
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import ExpandIcon from "@/components/utils/ExpandIcon.vue";

import "@/store/modules/forms/form5";
const form5State = namespace("Form5");

@Component({
    components:{
        ExpandIcon
    }
})
export default class NoticeOfHearingRspToAppealPg extends Vue {

    @form5State.Action
	public UpdateCurrentNoticeOfHearingOfAppealId!: (newCurrentNoticeOfHearingOfAppealId: string) => void        


    showReadyInfo = true;
    showHearingInfo = false;

    public showReady(show: boolean){
        if (show) {
            this.showReadyInfo = true;
            this.$emit('adjustHeights', 0, "17rem");
        } else {
            this.showReadyInfo = false;
            this.$emit('adjustHeights', 0, "0");
        }
    }

    public showHearing(show: boolean){
        if (show) {
            this.showHearingInfo = true;
            this.$emit('adjustHeights', 1, "17rem");
        } else {
            this.showHearingInfo = false;
            this.$emit('adjustHeights', 1, "0");
        }
    }

    public startNewForm5Document(){
        this.UpdateCurrentNoticeOfHearingOfAppealId(null);            
        this.$router.push({name: "start-form5" })
    }

}
